export default __webpack_public_path__ + "static/media/logo-google.b97dead2.png";